module.exports = __webpack_public_path__ + "static/media/daisie-mobile.6cffa4ee.png";